export default __webpack_public_path__ + "static/2_36-d5184acf87287d298a2563e0608eaf81.png";